
export default "/assets/chat-bubble-left-right-micro.666c4a5e.svg"